import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

export const usePagination = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const pageParam = searchParams.get('page');
  const page = pageParam ? parseInt(pageParam) : 1;

  const setPage = useCallback((page?: number) => {
    setSearchParams((params) => {
      if (page) {
        params.set('page', `${page}`);
      } else {
        params.delete('page');
      }

      return params;
    });
  }, [setSearchParams]);

  return {
    page,
    setPage,
  };
};
